import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'app-term-life-info',
  templateUrl: './term-life-info.component.html',
  styleUrls: ['./term-life-info.component.css']
})
export class TermLifeInfoComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  
  constructor(private serviceURLService: serviceURLService,private router: Router){}
  name: string;
  email: string;
  mobile: string;
  cards = [
    {
      icon: 'assets/icons/insta_payment.png',
      title: 'Insta payment on',
      subtitle: 'Claim intimation',
      description: 'Rs 2 lakh. will be paid out instantly on claim intimation.',
      extraContent: `On receipt of intimation of death (along with required documents), an amount of Rs. 2 Lacs shall be payable
      in advance within 3 working days from claim registration date provided mandatory documents are submitted and the remaining
      pay out shall be made after the claim is approved. The Insta Payment on Claim Intimation shall be payable only if the 
      death happens post payment and completion of 1 full policy year.
      This is an inbuilt feature. Documents required for claim intimation are Death Certificate, Cancelled Cheque / Bank account details,
      Claim intimation form, KYC of nominee and Policy document. On assessment of documents submitted during claim assessment, additional
      documents may be sought by the company.`,
      showExtra: false,
    },
    {
      icon: 'assets/icons/pay_later.png',
      title: 'Pay later buy up to',
      subtitle: '12 months multiple times',
      description: 'You can defer payments by enjoying policy benefits multiple times after 3 years at no additional cost.',
      extraContent: `Under Auto Cover Continuance option, you can delay premium payments for up to 12 months anytime after completion 
      of 3 years while policy benefits continue. This option can be availed multiple times during the coverage period with a minimum
      gap of 5 years from the last payment.`,
      showExtra: false
    },
    {
      icon: 'assets/icons/100_payment.png',
      title: '100% payout on',
      subtitle: 'terminal illness',
      description: 'Life cover of up to 1 cr will be paid in advance on diagnosis of terminal illness.',
      extraContent: `This amount will be payable on diagnosis of a life threatening disease by a Registered Medical Practitioner 
      during the policy duration.`,
      showExtra: false
    },
    {
      icon: 'assets/icons/tax_benifits.png',
      title: 'Tax Benefit',
      subtitle: '',
      description: '',
      extraContent: `The premium paid under term insurance is tax deductible under section 80C. Also, a payout of term 
      insurance claim is exempted from tax under section 10(10D), hence saving the money. `,
      showExtra: true
    },
  ];

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobileNumber');
  }

  toggleContent(index: number, event?: Event): void {
    if (event) {
      event.stopPropagation(); // Prevent event bubbling issues
    }

    // Toggle only the clicked card and close others
    this.cards = this.cards.map((card, i) => ({
      ...card,
      showExtra: i === index ? !card.showExtra : false
    }));
  }

  
  createProspectForTermMaxLife() {
      const data = {
        mobile: this.mobile,
        prospectId: "",
        quoteId: "",
        rmId: "",
        product: 146,
        email: this.email,
        name: this.name,
        company: "",
        location: "",
        designation: "",
        comment: "",
        partnerId: "997",
        channel: "Notify-App",
        leadSource: "Notify-App",
        googleClickID: "",
        couponCode: ""
      };
      this.serviceURLService.createProspect(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        // Auto assigment removed
        //  this.serviceURLService.createProspectForMaxLife(successData.data.prospectId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        // }, errorData => {
        // });
      }, errorData => {
      });
    }
}